import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import DashboardTopbar from "@/components/DashboardTopbar"
import EditProfileForm from "@/components/EditProfileForm"
import NotificationSettings from "@/components/NotificationSettings"
import ChangeEmailForm from "@/components/ChangeEmailForm"
import DeleteAccountForm from "@/components/DeleteAccountForm"

const SettingsPage = () => (
  <>
    <DashboardTopbar title="Settings" />

    <div className="padding mx-auto w-full max-w-xl space-y-8 py-6">
      <EditProfileForm />
      <NotificationSettings />
      <ChangeEmailForm />
      <DeleteAccountForm />
    </div>
  </>
)

export default SettingsPage

SettingsPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
